import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

module.exports = {
    createFetchParams: (entity, id, exclude) => ({
        entity,
        id,
        exclude
    }),
    ...storeModuleFactory({
        name:               'entitiesId',
        endpoint:           endpoints.entitiesId.endpoing,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: item => item
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/entitiesId.js